// AUTO-GENERATED by scripts/set-version.js — do not edit by hand.
export const APP_VERSION = '20261030.1';
export const BUILD_DATE = '10/30/2026, 7:21:40 AM';
